import loadable from '@loadable/component'

const HeaderMenu = loadable(
  () => import(
    './HeaderMenu.component'
  ),
)

export default HeaderMenu
